import React from 'react'
import styled from 'styled-components';

import { colors } from '../../../healtheraComponents';

const BranchCheckbox = ({ disabled = false, onChange, children, className, checked }) => {
  const handleCheckboxToggle = () => {
    if (disabled) return;

    onChange(!checked);
  };
 
  return (
    <Label disabled={disabled} active={checked} className={className}>
      {children}
      <HiddenInput type="checkbox" value={checked} onChange={handleCheckboxToggle} />
    </Label>
  )
};

const getActiveStyles = () => `
  background-color: #4DB181;
  color: white;
`;

const getDisabledStyles = () => `
  background-color: ${colors.FADED_LIGHT};
  color: ${colors.GRAY};
  cursor: default;
`;

const Label = styled.label`
  padding: 4px 16px;
  border-radius: 3px;
  
  color: #4DB181;
  font-weight: 600;
  
  cursor: pointer;
  background-color: #EFF9F1;
  user-select: none;
  transition: all .2s ease;

  ${(props) => props.active && getActiveStyles()}
  ${(props) => props.disabled && getDisabledStyles()}
`;

const HiddenInput = styled.input`
  display: none;
`;

export default BranchCheckbox
